import { formatDate, numberToQuantityString, quantityToNumber } from 'utils'

/** Normaliza quantidades de item da API para o formato do formulário (vírgula). */
export const mapOrderItemFromApi = (item: any) => ({
  ...item,
  quantity: numberToQuantityString(item.quantity),
  quantityUn: numberToQuantityString(item.quantityUn)
})

interface DirtRoadQuiz {
  quest1: number
  quest2: number
  quest3: number
  quest4: number
}
interface NormalizedData {
  proposalId: string
  customerId: string
  orderTypeId: string
  reserveOrder: number
  cdPedidoReserva: string
  colecao: string | null
  paymentResponsibleId: string
  opportunityId: string
  unityId: string
  deliveryDate: string | null
  requestedDate: string | null
  freightTypeId: string
  freightValue: number
  paymentTermId: string
  paymentMethodId: string
  deliveryAddressCompanyId: string
  entryValue: number
  entryPercent: number
  sellerId: string
  indicatorId: string
  saleChannelId: string
  priceTableId: string
  observation: string
  expeditionObs: string
  purchaseOrderId: string
  representantOrderNumber: string
  proposalValidity: string
  totalExpenses: number
  totalDiscount: number
  hasDirtyRoadQuiz: number
  dirtRoadQuiz: DirtRoadQuiz
  printObs: number
  commissionPercent: number
  items: Item[]
  installments: Installment[]
  total: any
}

interface Item {
  productId: string
  salePrice: number
  defaultPrice: number
  defaultPrice4: number
  currentPrice: number
  saleType: string
  priceTableId: string
  quantity: number
  groupQuantity: number
  pcpObservation: string
}

interface Installment {
  days: string
  dueDate: string
  value: number
  paymentMethod: {
    id: string
  }
}

export const normalizeOrderForm = (data: any): NormalizedData => {
  const cdPedidoReservaValue =
    typeof data?.cdPedidoReserva === 'string'
      ? data.cdPedidoReserva
      : data?.cdPedidoReserva?.orderId ||
        data?.cdPedidoReserva?.id ||
        data?.cdPedidoReserva?.proposalId ||
        ' '

  return {
    proposalId: data.proposalId,
    customerId: data?.customer?.id,
    orderTypeId: data?.orderType?.id,
    reserveOrder: data?.orderType?.id === 'P' ? 1 : 0,
    cdPedidoReserva: cdPedidoReservaValue,
    colecao: data?.crossSale?.id === 'YES' ? 'VD CRUZADA' : null,
    opportunityId: data?.opportunity?.id,
    paymentResponsibleId: data.paymentResponsible?.id,
    unityId: data?.unity?.id,
    deliveryDate: data?.deliveryDate || null,
    freightTypeId: data?.freightType?.id,
    freightValue: Number(data?.freightPrice || 0),
    deliveryAddressCompanyId: data?.deliveryAddressCompany?.id || '',
    paymentTermId: data?.paymentTerm?.id,
    paymentMethodId: data?.paymentMethod?.id || ' ',
    entryValue: Number(data?.entryValue || 0),
    entryPercent: Number(data?.entryPercent || 0),
    sellerId: data?.seller?.id,
    indicatorId: data?.indicator?.id,
    saleChannelId: data?.saleChannel?.id || ' ',
    priceTableId: data?.priceTable?.id,
    observation: data?.observation || ' ',
    printObs: +data?.printObs,
    commissionPercent: Number(data?.commissionPercent || 0),
    expeditionObs: data?.expeditionObs,
    purchaseOrderId: data?.purchaseOrder,
    representantOrderNumber: data?.representantOrderNumber || '',
    requestedDate: data?.requestedDate
      ? formatDate(data?.requestedDate, 'yyyy-MM-dd')
      : null,
    proposalValidity: formatDate(data?.proposalValidity, 'yyyy-MM-dd'),
    totalExpenses: Number(data?.totalExpenses || 0),
    totalDiscount: Number(data?.totalDiscount || 0),
    hasDirtyRoadQuiz: Number(data?.hasDirtRoadQuiz?.id || 0),
    total: data.total,
    dirtRoadQuiz: {
      quest1: Number(data?.dirtRoadQuizQuest1),
      quest2: Number(data?.dirtRoadQuizQuest2?.id),
      quest3: Number(data?.dirtRoadQuizQuest3?.id),
      quest4: Number(data?.dirtRoadQuizQuest4?.id)
    },
    items: data?.items?.map((item: any) => ({
      productId: item?.product?.id,
      salePrice: Number(item?.salePrice),
      defaultPrice: Number(item?.defaultPrice || 0.01),
      defaultPrice4: Number(item?.defaultPrice4 || 0),
      currentPrice: Number(item?.currentPrice || item?.defaultPrice || 0.01),
      saleType: item?.saleType || '12',
      priceTableId: ' ',
      quantity: quantityToNumber(item?.quantity),
      groupQuantity: quantityToNumber(item?.groupQuantity || item?.quantity),
      pcpObservation: item?.pcpObservation,
      configurationId: item.configurationId,
      origin: Number(item.origin) || 0,
      icmsPercent: Number(item.icmsPercent),
      ipiPercent: Number(item.ipiPercent),
      stPercent: Number(item.stPercent),
      quantityUn: quantityToNumber(item.quantityUn),
      sequence: Number(item.sequence),
      ruleId: item.ruleId,
      xPed: item?.xPed || '',
      nItemPed: item?.nItemPed || ''
    })),
    installments:
      data?.installments?.map((installment: Installment) => ({
        days: installment?.days,
        dueDate: installment.dueDate,
        value: Number(installment?.value),
        paymentMethodId: installment?.paymentMethod?.id
      })) || []
  }
}
